module.exports = __webpack_public_path__ + "static/media/gallery (6).7a34d720.jpg";